"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _dialog = _interopRequireDefault(require("@/mixins/dialog"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** services */
/** mixins */
var _default2 = exports.default = {
  mixins: [_dialog.default],
  props: {
    // 所有下拉options配置
    /**
     * optConfig.visitPurposeOptions: [], // 拜访目的select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      formLabelWidth: '120px',
      // isShowModel: false, // from mixins
      info: {},
      // 当前处理的计划info
      /** form group */
      pickerOptions: {
        start: '00:00',
        end: '23:30',
        step: '00:30'
      },
      form: {
        visitPurpose1: '',
        visitPurpose2: '',
        remark: ''
      },
      initForm: {
        visitPurpose1: '',
        visitPurpose2: '',
        remark: ''
      },
      rules: {
        visitPurpose1: [{
          required: true,
          trigger: ['change'],
          message: this.$t('doubleWeekPlan.error.visitPurpose')
        }],
        visitPurpose2: [{
          required: true,
          trigger: ['change'],
          message: this.$t('doubleWeekPlan.error.visitPurpose')
        }],
        remark: [{
          required: true,
          trigger: ['change'],
          message: this.$t('doubleWeekPlan.error.desc')
        }]
      },
      /** other */
      canSubmit: true
    };
  },
  computed: {
    startOptions: function startOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        maxTime: this.form.planTaskEndTime
      });
    },
    endOptions: function endOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        minTime: this.form.planTaskStartTime
      });
    },
    // 计划类型为 潜在客户
    isTypeSpec: function isTypeSpec() {
      return ['A10'].indexOf(this.form.planTaskType) >= 0;
    }
  },
  methods: {
    // open dialog init
    init: function init(info) {
      var _this = this;
      console.log(12312, info);
      // 没有选中计划不能操作
      if (!info.planTaskInfoPk) {
        return false;
      }
      this.isShowModel = true;
      this.info = info;
      // 初始化编辑数据
      var newForm = {
        visitPurpose1: info.visitPurposeOne,
        visitPurpose2: info.visitPurposeTwo,
        remark: info.remark
      };
      this.form = Object.assign({}, newForm);
      this.initForm = Object.assign({}, newForm);
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });
    },
    // save event
    saveItem: function saveItem() {
      var _this2 = this;
      console.log(999, this.form);
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        // 重复触发
        if (!_this2.canSubmit) {
          return false;
        }
        _this2.canSubmit = false;
        var params = (0, _objectSpread2.default)({
          planTaskInfoPk: _this2.info.planTaskInfoPk || ''
        }, _this2.form);
        (0, _doubleWeekPlan.savePlanTarget)(params).then(function () {
          _this2.$message({
            message: _this2.$t('common.saveSuccess'),
            type: 'success'
          });
          _this2.$emit('refresh');
          _this2.isShowModel = false;
        }).catch(function () {}).finally(function () {
          _this2.canSubmit = true;
        });
      });
    }
  }
};